const headers = {
  name: "Employee Role",
  navigate: {
    path: [
      {
        name: "Roles",
        path: "/app/employees/roles",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
